<template>
  <component
    v-bind="$attrs"
    :is="link ? 'router-link' : 'div'"
    class="inline-flex items-center justify-items-start rounded-full py-1 pl-2 pr-[10px]"
    :class="[
      { 'pr-[6px]': link },
      { 'bg-gpx_red-300': color === 'red' },
      { 'bg-gpx_yellow-300': color === 'yellow' },
      { 'bg-gpx_blue-300': color === 'blue' },
      { 'bg-gpx_green-300': color === 'green' },
      { 'bg-gpx_porto-900': color === 'porto' },
      { 'bg-gpx_gray-800': color === 'gray' }
    ]"
  >
    <div
      class="h-2 w-2 rounded-full"
      :class="[
        { 'bg-gpx_red-200': color === 'red' },
        { 'bg-gpx_yellow-200': color === 'yellow' },
        { 'bg-gpx_blue-200': color === 'blue' },
        { 'bg-gpx_green-200': color === 'green' },
        { 'bg-gpx_porto-400': color === 'porto' },
        { 'bg-gpx_gray-100': color === 'gray' }
      ]"
    ></div>
    <div
      class="ml-1.5 text-xs font-medium capitalize"
      :class="[
        { 'text-gpx_red-100': color === 'red' },
        { 'text-gpx_yellow-100': color === 'yellow' },
        { 'text-gpx_blue-100': color === 'blue' },
        { 'text-gpx_green-100': color === 'green' },
        { 'text-gpx_porto-100': color === 'porto' },
        { 'text-gpx_black-500': color === 'gray' }
      ]"
    >
      {{ statusText }}{{ suffix }}
    </div>
    <div v-if="link" class="relative ml-[2px] h-[18px] w-[18px]">
      <ArrowRightIcon
        class="heroicon-stroke-w-2 absolute left-1/2 top-1/2 h-[13px] w-[13px] -translate-x-1/2 -translate-y-1/2 -rotate-45"
        :class="[
          { 'text-gpx_red-100': color === 'red' },
          { 'text-gpx_yellow-100': color === 'yellow' },
          { 'text-gpx_blue-100': color === 'blue' },
          { 'text-gpx_green-100': color === 'green' },
          { 'text-gpx_porto-100': color === 'porto' },
          { 'text-gpx_black-500': color === 'gray' }
        ]"
      />
    </div>
  </component>
</template>

<script>
import upperFirst from 'lodash/upperFirst'
import { statusColorMap } from '@gpx-spa/constants'
import { ArrowRightIcon } from '@heroicons/vue/24/outline'

export default {
  props: {
    status: {
      type: String
    },
    label: {
      type: String
    },
    suffix: {
      type: String
    },
    colorOverride: {
      type: String
    },
    link: {
      type: Boolean,
      default: false
    }
  },

  components: {
    ArrowRightIcon
  },

  computed: {
    color() {
      return this.colorOverride || statusColorMap[this.status]
    },
    statusText() {
      if (this.label) {
        return this.label
      }

      const statusMap = {
        'ach-requested': 'ACH Requested',
        'pending-approval': 'Pending Approval',
        'pending-renewal': 'Pending Renewal',
        'pending-cancellation': 'Pending Cancellation',
        'pending-shipment': 'Pening Shipment',
        'partial-refund': 'Partially Refunded',
        'on-hold': 'On Hold',
        confirmed: 'Confirmed',
        archived: 'Cancelled & Archived',
        blocked: 'Blocked'
      }
      return statusMap[this.status] || upperFirst(this.status)
    }
  },

  methods: {
    upperFirst
  }
}
</script>
